// =========================================================
// * Vuetify Material Dashboard PRO - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import './plugins/vue-world-map'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import AuthService from './views/dashboard/AuthService.js'
import FilesConvert from './views/dashboard/FilesConvert.js'
import PapaParse from 'vue-papa-parse'

Vue.config.productionTip = false

Vue.prototype.$Auth = new AuthService(process.env.VUE_APP_ENV_URL)
Vue.prototype.$FilesConvert = new FilesConvert()
Vue.prototype.$chartColors = [
  { r: 255, g: 198, b: 1 },
  { r: 90, g: 61, b: 145 },
  { r: 106, g: 205, b: 239 },
  { r: 135, g: 135, b: 135 },
]

Vue.use(PapaParse)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
